/**
 * Mount Rigi Drawer Manager
 *
 * Koordiniert:
 * - Mobile navigation
 * - Collection filters
 * - Future cart drawer
 *
 * Es kann immer nur ein Drawer gleichzeitig geöffnet sein.
 */

(() => {
  if (window.MRDrawerManager) return;

  const drawers = new Map();
  let activeDrawerId = null;

  const updateScrollLock = () => {
    const locked = activeDrawerId !== null;

    document.documentElement.classList.toggle(
      'mr-drawer-is-open',
      locked
    );

    document.body?.classList.toggle(
      'mr-drawer-is-open',
      locked
    );
  };

  const register = (id, controller) => {
    if (!id || !controller) return;

    drawers.set(id, controller);
  };

  const unregister = (id) => {
    if (!id) return;

    if (activeDrawerId === id) {
      activeDrawerId = null;
      updateScrollLock();
    }

    drawers.delete(id);
  };

  const close = (
    id = activeDrawerId,
    options = {}
  ) => {
    if (!id) return;

    const controller = drawers.get(id);

    if (!controller) {
      if (activeDrawerId === id) {
        activeDrawerId = null;
        updateScrollLock();
      }

      return;
    }

    controller.close?.({
      restoreFocus:
        options.restoreFocus !== false,
      fromManager: true
    });

    if (activeDrawerId === id) {
      activeDrawerId = null;
    }

    updateScrollLock();
  };

  const closeAll = (options = {}) => {
    const ids = Array.from(drawers.keys());

    ids.forEach((id) => {
      const controller = drawers.get(id);

      if (controller?.isOpen?.()) {
        controller.close?.({
          restoreFocus:
            options.restoreFocus !== false,
          fromManager: true
        });
      }
    });

    activeDrawerId = null;
    updateScrollLock();
  };

  const open = (id) => {
    if (!id) return;

    const controller = drawers.get(id);

    if (!controller) return;

    if (
      activeDrawerId &&
      activeDrawerId !== id
    ) {
      close(activeDrawerId, {
        restoreFocus: false
      });
    }

    controller.open?.({
      fromManager: true
    });

    activeDrawerId = id;
    updateScrollLock();
  };

  const toggle = (id) => {
    const controller = drawers.get(id);

    if (!controller) return;

    if (controller.isOpen?.()) {
      close(id);
    } else {
      open(id);
    }
  };

  document.addEventListener(
    'keydown',
    (event) => {
      if (
        event.key === 'Escape' &&
        activeDrawerId
      ) {
        close(activeDrawerId);
      }
    }
  );

  window.MRDrawerManager = {
    register,
    unregister,
    open,
    close,
    closeAll,
    toggle,
    getActiveId: () => activeDrawerId
  };
})();
